/* @ngInject */
export default class ProjectLabelFilterController {
    constructor($scope, $timeout, labels, SensorService, onUpdateLabels, onClose) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.SensorService = SensorService;
        this.onUpdateLabels = onUpdateLabels;
        this.onClose = onClose;
        
        // Initialize with passed labels
        this.labels = labels.length > 0 ? [...labels] : [{ key: '', value: '' }];
        
        // Autocomplete state
        this.availableLabelKeys = [];
        this.availableLabelValues = {};
        this.filteredLabelKeys = {};
        this.filteredLabelValues = {};
        this.showKeysDropdown = {};
        this.showValuesDropdown = {};
        this.selectedKeyIndex = {};
        this.selectedValueIndex = {};
        this.isSelecting = false;
        
        // Fetch available label keys
        this.fetchLabelKeys();
    }

    fetchLabelKeys() {
        this.SensorService.listLabelKeys().then(response => {
            // Use only project label keys
            const keyMap = new Map();
            
            if (response.projectLabelKeys) {
                response.projectLabelKeys.forEach(item => {
                    if (keyMap.has(item.key)) {
                        keyMap.get(item.key).deviceCount += item.deviceCount;
                    } else {
                        keyMap.set(item.key, {
                            key: item.key,
                            deviceCount: item.deviceCount,
                            type: 'project'
                        });
                    }
                });
            }
            
            // Convert map to array
            this.availableLabelKeys = Array.from(keyMap.values());
            
            // Sort by device count (descending)
            this.availableLabelKeys.sort((a, b) => b.deviceCount - a.deviceCount);
        }).catch(error => {
            // eslint-disable-next-line no-console
            console.error('Error fetching label keys:', error);
            this.availableLabelKeys = [];
        });
    }

    fetchLabelValues(index) {
        const label = this.labels[index];
        if (!label.key || !label.key.trim()) {
            return;
        }

        this.SensorService.listLabelValues(label.key.trim()).then(response => {
            // Use only project label values
            const valueMap = new Map();
            
            if (response.projectLabelValues) {
                response.projectLabelValues.forEach(item => {
                    if (valueMap.has(item.value)) {
                        valueMap.get(item.value).deviceCount += item.deviceCount;
                    } else {
                        valueMap.set(item.value, {
                            value: item.value,
                            deviceCount: item.deviceCount,
                            type: 'project'
                        });
                    }
                });
            }
            
            // Convert map to array
            this.availableLabelValues[index] = Array.from(valueMap.values());
            
            // Sort by device count (descending)
            this.availableLabelValues[index].sort((a, b) => b.deviceCount - a.deviceCount);
            
            this.$scope.$applyAsync();
        }).catch(error => {
            // eslint-disable-next-line no-console
            console.error('Error fetching label values:', error);
            this.availableLabelValues[index] = [];
        });
    }

    onKeyInputFocus(index) {
        this.filterLabelKeys(index);
        this.showKeysDropdown[index] = true;
    }

    onKeyInputBlur(index) {
        if (this.isSelecting) {
            return;
        }
        
        this.$timeout(() => {
            if (!this.isSelecting) {
                this.showKeysDropdown[index] = false;
                this.selectedKeyIndex[index] = -1;
            }
        }, 200);
    }

    onKeyInputChange(index) {
        this.filterLabelKeys(index);
        this.selectedKeyIndex[index] = -1;
    }

    filterLabelKeys(index) {
        const searchTerm = (this.labels[index].key || '').toLowerCase();
        this.filteredLabelKeys[index] = this.availableLabelKeys.filter(item =>
            item.key.toLowerCase().includes(searchTerm)
        );
    }

    selectLabelKey(index, key, $event) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        
        this.isSelecting = true;
        this.labels[index].key = key;
        this.showKeysDropdown[index] = false;
        this.selectedKeyIndex[index] = -1;
        
        this.fetchLabelValues(index);
        
        this.$timeout(() => {
            this.isSelecting = false;
        }, 100);
        
        this.$scope.$applyAsync();
    }

    onValueInputFocus(index) {
        if (!this.availableLabelValues[index]) {
            this.fetchLabelValues(index);
        }
        this.filterLabelValues(index);
        this.showValuesDropdown[index] = true;
    }

    onValueInputBlur(index) {
        if (this.isSelecting) {
            return;
        }
        
        this.$timeout(() => {
            if (!this.isSelecting) {
                this.showValuesDropdown[index] = false;
                this.selectedValueIndex[index] = -1;
            }
        }, 200);
    }

    onValueInputChange(index) {
        this.filterLabelValues(index);
        this.selectedValueIndex[index] = -1;
    }

    filterLabelValues(index) {
        if (!this.availableLabelValues[index]) {
            this.filteredLabelValues[index] = [];
            return;
        }
        
        const searchTerm = (this.labels[index].value || '').toLowerCase();
        this.filteredLabelValues[index] = this.availableLabelValues[index].filter(item =>
            item.value.toLowerCase().includes(searchTerm)
        );
    }

    selectLabelValue(index, value, $event) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        
        this.isSelecting = true;
        this.labels[index].value = value;
        this.showValuesDropdown[index] = false;
        this.selectedValueIndex[index] = -1;
        
        this.$timeout(() => {
            this.isSelecting = false;
        }, 100);
        
        this.$scope.$applyAsync();
    }

    getCountDisplayText(count) {
        if (count >= 1000) {
            return `${(count / 1000).toFixed(1)}k`;
        }
        return count.toString();
    }

    addLabel() {
        if (this.labels.length < 10) {
            this.labels.push({ key: '', value: '' });
        }
    }

    removeLabel(index) {
        this.labels.splice(index, 1);
        if (this.labels.length === 0) {
            this.labels = [{ key: '', value: '' }];
        }
    }
    
    canAddMoreLabels() {
        return this.labels.length < 10;
    }

    clear() {
        this.labels = [{ key: '', value: '' }];
        this.apply();
    }

    apply() {
        this.onUpdateLabels(this.labels);
        this.onClose();
    }
}

